import {
  Card,
  Box,
  BlockStack,
  InlineStack,
  Divider,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonThumbnail,
} from "@shopify/polaris";

/**
 * Loading placeholder for the department detail page. Mirrors the real layout
 * (identity hero + stats strip + member rows) so the swap to loaded content is
 * seamless — no layout shift. The identity color is known from the id up front,
 * so the accent bar + soft tint render on the very first frame.
 */
function DepartmentDetailSkeleton({
  accent,
  accentSoft,
}: {
  accent: string;
  accentSoft: string;
}) {
  return (
    <BlockStack gap="400">
      <Card padding="0">
        <div
          style={{ background: accentSoft, borderLeft: `4px solid ${accent}` }}
        >
          <Box padding="400">
            <InlineStack gap="300" blockAlign="center">
              <SkeletonThumbnail size="small" />
              <div style={{ flex: 1, maxWidth: 320 }}>
                <BlockStack gap="200">
                  <SkeletonBodyText lines={2} />
                </BlockStack>
              </div>
            </InlineStack>
          </Box>
        </div>
        <Divider />
        <Box padding="400">
          <InlineStack gap="1200">
            {[0, 1, 2].map((i) => (
              <div key={i} style={{ width: 64 }}>
                <BlockStack gap="150">
                  <SkeletonBodyText lines={1} />
                  <SkeletonDisplayText size="small" />
                </BlockStack>
              </div>
            ))}
          </InlineStack>
        </Box>
      </Card>

      <Card padding="0">
        <Box padding="400">
          <InlineStack align="space-between" blockAlign="center">
            <div style={{ width: 160 }}>
              <SkeletonDisplayText size="small" />
            </div>
            <div style={{ width: 150 }}>
              <SkeletonBodyText lines={1} />
            </div>
          </InlineStack>
        </Box>
        <Divider />
        {[0, 1, 2, 3].map((i) => (
          <div key={i}>
            {i > 0 ? <Divider /> : null}
            <Box padding="400">
              <InlineStack gap="300" blockAlign="center">
                <SkeletonThumbnail size="small" />
                <div style={{ flex: 1, maxWidth: 240 }}>
                  <SkeletonBodyText lines={1} />
                </div>
              </InlineStack>
            </Box>
          </div>
        ))}
      </Card>
    </BlockStack>
  );
}

export default DepartmentDetailSkeleton;
